import React from "react";
const RenderIfAvailable = ({ value, children }) => {
  if (!(value || value?.length)) return null;
  return children;
};

export default React.memo(RenderIfAvailable)